import useGetMemberClinicalData from './api/useGetMemberClinicalData';
import { hasEhrRecord } from './utils/clinicalSummary';

const useShowEhrRecord = (memberId: number | null | undefined) => {
    const { data, isLoading } = useGetMemberClinicalData(memberId);

    return { showEhrRecord: hasEhrRecord(data), isLoading };
};

export default useShowEhrRecord;
